import React, { useState, useEffect } from 'react';
import en from '../../../locales/en.json';
import mk from '../../../locales/mk.json';
import al from '../../../locales/al.json';
import '../../../styles/home.desktop.scss';
import '../../../styles/home.mobile.scss';
import './privacypolicy.scss';
import PageTemplate, { Lang } from '../../../components/layout/PageTemplate';

const fullLocaleMap = { en, mk, al };

const privacyLocaleMap = {
  en: (en.privacy || {}),
  mk: (mk.privacy || {}),
  al: (al.privacy || {}),
};

function getInitialLang(): Lang {
  const stored = localStorage.getItem('lang');
  if (stored === 'en' || stored === 'mk' || stored === 'al') return stored;
  return 'mk';
}

const PrivacyPolicyView: React.FC = () => {
  const [lang, setLang] = useState<Lang>(getInitialLang());
  const t = privacyLocaleMap[lang] as Record<string, string>;
  const pageT = fullLocaleMap[lang];

  useEffect(() => {
    localStorage.setItem('lang', lang);
  }, [lang]);

  return (
    <PageTemplate lang={lang} setLang={setLang} t={pageT} forceScrolled={true}>
      <div className="privacy-policy-container">
        <h1>{t.title}</h1>
        <ol>
          {Object.keys(t)
            .filter((k) => k !== 'title')
            .sort((a, b) => Number(a) - Number(b))
            .map((k) => (
              <li key={k}>{t[k]}</li>
            ))}
        </ol>
      </div>
    </PageTemplate>
  );
};

export default PrivacyPolicyView;
